import * as React from 'react';
import PropTypes from 'prop-types';
import { StaticImage } from 'gatsby-plugin-image';
import UAParser from 'ua-parser-js';

import Button from '../Button';

import './style.scss';

function checkUALabel(ua) {
  let parser = new UAParser();
  let result = parser.getResult();

  if (result.os.name === ua) {
    return true;
  } else {
    return false;
  }
}


const CTABanner = props => {
  return (
    <div className="cta-banner">
      <div className="container">
        <div data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease">
          {props.cover ? props.cover : <StaticImage className="cover" src="./assets/cover.jpg" alt="Cover of Professional Standards Councils' 2020/21 Annual Report" width={192} />}
        </div>
        <div
          className="content"
          data-sal="slide-up"
          data-sal-duration="1000"
          data-sal-delay="300"
          data-sal-easing="ease"
        >
          <h2 className="title">Read more about this chapter in the Councils' 2020/21 Annual Report</h2>
          <Button
            color="primary"
            annualReportPage={props.annualReportPage}
            label={checkUALabel("Android") ? "Download" : "Read more"}
            srLabelContinuation="in our annual report"
            icon="link"
            openInNewTab
          />
        </div>
      </div>
    </div>
  );
};

CTABanner.propTypes = {
  annualReportPage: PropTypes.number,
};

export default CTABanner;
